import DisclosureLayoutGroupProvider from './hooks/useDisclosureLayoutGroup';

import { DisclosureLayoutGroupProps } from './@types/DisclosureLayoutGroupProps';
// import { DisclosureLayoutGroup as LayoutGroupVtex } from '@vtex/disclosure';

const DisclosureLayoutGroup = (props: DisclosureLayoutGroupProps) => (
	<DisclosureLayoutGroupProvider {...props}>
		{/* <div> */}
		{/* <LayoutGroupVtex maxVisible={props.maxVisible}> */}
		{props.children}
		{/* </LayoutGroupVtex> */}
		{/* </div> */}
	</DisclosureLayoutGroupProvider>
);

export default DisclosureLayoutGroup;
